import { errorHandlerFx } from '../../../../../model/errorHandler';
import { createEffectJWT } from '../../../../../model/JWT';
import { organizationCreate } from '../../../../../apiRPC/organization';

export const organizationCreateFX = errorHandlerFx(
  createEffectJWT(organizationCreate),
  [99],
);
